
angular.module("ainapp").controller("productConfigurationController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService",
    "localStorageService", "$window", function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

        $scope.PageName = "Product Configuration";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.getCurrentData = function () {
            $scope.selectedItems = [];

            $scope.fields = [
                {
                    field: "ProductCode",
                    title: "Code",
                    width: "100px",
                    type: "string"
                },
                {
                    field: "Name",
                    title: "Name",
                    width: "250px",
                    type: "string"
                },
                {
                    field: "NameAr",
                    title: "Name Ar",
                    width: "250px",
                    type: "string"
                },
                {
                    field: "BarCode",
                    title: "Bar Code",
                    type: "string"
                },
                {
                    field: "Specification",
                    title: "Specification",
                    type: "string"
                },
                {
                    field: "ProductType",
                    title: "Product Type",
                    type: "string"
                },
                {
                    field: "Model",
                    title: "Model",
                    type: "string"
                },
                {
                    field: "SupplierName",
                    title: "Supplier",
                    type: "string"
                },
                {
                    field: "DepreciationYear",
                    title: "Depreciation Year",
                    type: "string"
                },
                {
                    field: "AMCCompany",
                    title: "AMC Company",
                    type: "string"
                },
                {
                    field: "SellPrice",
                    title: "Sell Price",
                    type: "number"
                },
                {
                    field: "PurchasePrice",
                    title: "Purchase Price",
                    type: "number"
                },
                {
                    field: "AveragePrice",
                    title: "Average Price",
                    type: "number"
                },
                {
                    field: "Description",
                    title: "Description",
                    type: "string"
                },
                {
                    field: "WarrantyDate",
                    title: "Warranty Date",
                    type: "date",
                    template: "#= kendo.toString(kendo.parseDate(WarrantyDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                },
                {
                    field: "Length",
                    title: "Length",
                    type: "number"
                },
                {
                    field: "Width",
                    title: "Width",
                    type: "number"
                },
                {
                    field: "Height",
                    title: "Height",
                    type: "number"
                },
                {
                    field: "Volume",
                    title: "Volume",
                    type: "number"
                },
                {
                    field: "Weight",
                    title: "Weight",
                    type: "number"
                },
                {
                    field: "GrossWeight",
                    title: "Gross Weight",
                    type: "number"
                },
                {
                    field: "LastSalePrice",
                    title: "Last Sale Price",
                    type: "number"
                },
                {
                    field: "LastPurchasePrice",
                    title: "Last Purchase Price",
                    type: "number"
                },
                {
                    field: "YRRefNo",
                    title: "YRRefNo",
                    type: "string"
                },
                {
                    field: "manufacturing",
                    title: "manufacturing",
                    type: "string"
                },
                {
                    field: "CategoryName",
                    title: "Category",
                    type: "string"
                },
                {
                    field: "BrandName",
                    title: "Brand",
                    type: "string"
                },
                {
                    field: "CountryName",
                    title: "Country",
                    type: "string"
                },
                {
                    field: "HSCode",
                    title: "HS_Code",
                    type: "string"
                },
                {
                    field: "Balance",
                    title: "Balance",
                    type: "string"
                },



            ]


            $scope.VDesign = {};
            MainService.GetProductDesign().then(function (response) {
                $scope.VDesign = response.data;

                if (1 == 1) {
                    if ($scope.VDesign.IsField1) {
                        var f = {
                            field: "Field1",
                            title: $scope.VDesign.Field1Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField2) {
                        var f = {
                            field: "Field2",
                            title: $scope.VDesign.Field2Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField3) {
                        var f = {
                            field: "Field3",
                            title: $scope.VDesign.Field3Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField4) {
                        var f = {
                            field: "Field4",
                            title: $scope.VDesign.Field4Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField5) {
                        var f = {
                            field: "Field5",
                            title: $scope.VDesign.Field5Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField6) {
                        var f = {
                            field: "Field6",
                            title: $scope.VDesign.Field6Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField7) {
                        var f = {
                            field: "Field7",
                            title: $scope.VDesign.Field7Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField8) {
                        var f = {
                            field: "Field8",
                            title: $scope.VDesign.Field8Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField9) {
                        var f = {
                            field: "Field9",
                            title: $scope.VDesign.Field9Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField10) {
                        var f = {
                            field: "Field10",
                            title: $scope.VDesign.Field10Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField11) {
                        var f = {
                            field: "Field11",
                            title: $scope.VDesign.Field11Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField12) {
                        var f = {
                            field: "Field12",
                            title: $scope.VDesign.Field12Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField13) {
                        var f = {
                            field: "Field13",
                            title: $scope.VDesign.Field13Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField14) {
                        var f = {
                            field: "Field14",
                            title: $scope.VDesign.Field14Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField15) {
                        var f = {
                            field: "Field15",
                            title: $scope.VDesign.Field15Name,
                            type: "string"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField16) {
                        var f = {
                            field: "Field16",
                            title: $scope.VDesign.Field16Name,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field16, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField17) {
                        var f = {
                            field: "Field17",
                            title: $scope.VDesign.Field17Name,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field17, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField18) {
                        var f = {
                            field: "Field18",
                            title: $scope.VDesign.Field18Name,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(Field18, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField19) {
                        var f = {
                            field: "Field19",
                            title: $scope.VDesign.Field19Name,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(IsField19, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField20) {
                        var f = {
                            field: "Field20",
                            title: $scope.VDesign.Field20Name,
                            type: "date",
                            template: "#= kendo.toString(kendo.parseDate(IsField20, 'yyyy-MM-dd'), 'dd/MM/yyyy') #"
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField21) {
                        var f = {
                            field: "Field21",
                            title: $scope.VDesign.Field21Name,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField22) {
                        var f = {
                            field: "Field22",
                            title: $scope.VDesign.Field22Name,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField23) {
                        var f = {
                            field: "Field23",
                            title: $scope.VDesign.Field23Name,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField24) {
                        var f = {
                            field: "Field24",
                            title: $scope.VDesign.Field24Name,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }
                    if ($scope.VDesign.IsField25) {
                        var f = {
                            field: "Field25",
                            title: $scope.VDesign.Field25Name,
                            type: "number",
                        };
                        $scope.fields.push(f);
                    }

                }

                $scope.fields2 = angular.copy($scope.fields);


                var array = JSON.parse($scope.VDesign.ProductViewOrder);
                if (array != null) {
                    $scope.selectedItems = array;
                }


            });


        };

        $scope.init = function () {
            $scope.selectedItems = [];
            $scope.getCurrentData();
        };
        $scope.init();

        // Array to hold selected items with title
        $scope.selectedItems = [];

        // Function to add a new item selection row
        $scope.addItem = function () {
            $scope.selectedItems.push({
                field: "",
                type: "",
                title: ""
            });
        };

        // Function to remove an item selection row
        $scope.removeItem = function (data) {
            var index = $scope.selectedItems.indexOf(data);
            $scope.selectedItems.splice(index, 1);
        };

        // Function to update the type when a field is selected
        $scope.updateType = function (item) {
            angular.forEach($scope.fields, function (e) {
                if (item.field == e.field) {
                    item.selectedField = e;
                    item.type = e.type;
                    item.title = e.title;
                }
            });
        };


        $scope.saveConfiguration = function () {
            $.LoadingOverlay("show", {
                image: "images/load.gif"
            });

            $scope.result = [];

            $scope.selectedItems.forEach(function (e) {
                $scope.fields2.forEach(function (item) {
                    if (item.field == e.field) {
                        //                            $scope.result.push({
                        //                                field: e.field,
                        //                                type: item.type,
                        //                                title: item.title
                        //                            })
                        $scope.result.push(item);
                    }
                });
            });

            var TableArray = { ProductViewOrder: JSON.stringify($scope.result) };

            MainService.AddProductConfiguration(TableArray).then(
                function (response) {
                    if (response.data) {
                        toastr.success("Success");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }
            );
        };


    }
]);
